/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Input, Row, Table, Col, Button, Modal, Radio, InputNumber, Carousel, Collapse,Select, Checkbox } from "antd";
import type { RadioChangeEvent } from 'antd';
import {  DownOutlined } from "@ant-design/icons";
import ReactECharts from 'echarts-for-react';
import { roundToTwoDecimals, missingYearsFill } from '../../utils/utils';
import "./index.scss";

const { Panel } = Collapse;
const {Option}= Select;

const EndpointDetails = (props) => {

  const getHistMeasureTimepoints = (histMeasureTimepointList, modifiersList, arrayLength) => {

    let topData = histMeasureTimepointList?
                        [...histMeasureTimepointList]
                        .filter(item => item.number_of_studies !== 0)
                        .sort((a, b) => b.number_of_studies - a.number_of_studies)
                        .slice(0, endpointNum)
                        : [];

    let sortedData = topData ?
                        [...topData].sort((a, b) => a.duration - b.duration)
                        : [];

    let returnData = [];
    for (let index = 0; index < arrayLength; index++) {
        returnData.push( {
        key: index+1+'',
        name: index+1+'',
        history: sortedData&&sortedData[index]?.duration || null,
        modifiers: modifiersList&&modifiersList[index] != null ? modifiersList[index] : null,
      });
    }
    return returnData
  };

  const initialEndpoint = {
    "endpoint_std_term": "",
    "endpoint_category": "",
    "primary_frequency": null,
    "secondary_frequency": null,
    "endpoint_id": null,
    "cost": null,
    "endpoint_type": '',
    "modality": [],
    "usage_data" : [],
    "hist_usage_data" : [],
    'user_duration':[],
    "hist_measure_timepoints":[],
    "total_trial" : null,
    "added": false,
    'endpoint_context': "",
    "details": [],
  } 

  const {
    whetherModal,
    selectedData,
    isBuilderTable
  } = props    

  const [addActivityModal, setAddActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(initialEndpoint)

  const [endpointType, setEndpointType] = useState('');
  const [endpointContext, setEndpointContext] = useState('');
  const [endpointNum, setEndpointNum] = useState(selectedData['user_duration']&&selectedData['user_duration']?.length || null);

  const [enpointTypeError, setEnpointTypeError] = useState("")
  const [timepointsError, setTimepointsError] = useState("")
  const [timepointsLimitError, setTimepointsLimitError] = useState("")
  const [contextError, setContextError] = useState("");
  const [errorIndices, setErrorIndices] = useState([]);

  const [detailData, setDetailData] = useState(getHistMeasureTimepoints(selectedData['hist_measure_timepoints'], selectedData['user_duration'], selectedData['user_duration']?.length))
  
  const [whetherExpand, setWhetherExpand] = useState(false);
  const [open, setOpen] = useState(false);
  const [expandActiveKey, setExpandActiveKey] = useState<string | string[]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const expandArray = Array.from({ length: selectedActivity['details']?.length ??0 }, (v, i) => i + 1 + '');

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [multipleEndpointSelected, setmultipleEndpointSelected ] = useState(false); 

  const handleChange = (value: string[]) => {
    setSelectedOptions(value);
    setmultipleEndpointSelected(value.length > 1);
  };

  useEffect(() => {    
    setSelectedActivity(selectedData)    
    setAddActivityModal(whetherModal)
    setEndpointContext(selectedData["endpoint_context"])
    setEndpointType(selectedData["endpoint_type"])

    const tempEndpointNum = selectedData['user_duration']&&selectedData['user_duration']?.length || null
    setEndpointNum(tempEndpointNum)

    let temp = getHistMeasureTimepoints(selectedData['hist_measure_timepoints'], selectedData['user_duration'], tempEndpointNum)

    setDetailData(temp)
  }, [whetherModal, selectedData])
  
  useEffect(() => {
    let temp = getHistMeasureTimepoints(selectedActivity['hist_measure_timepoints'], selectedActivity['user_duration'], endpointNum)
    setDetailData(temp)
  },[selectedActivity]);

  useEffect(() => {
    let temp = getHistMeasureTimepoints(selectedActivity['hist_measure_timepoints'], detailData.map(item => item.modifiers), endpointNum)
    setDetailData(temp)
  },[endpointNum]);

  const onEndpointTypeChange = (e: RadioChangeEvent) => {
    setEndpointType(e.target.value);
    validateEndpointType(e.target.value)
  };

  const onInputNumberChange = (value: number) => {
    setEndpointNum(value)
    validateTimepoints(value)
  };

  const onContextChange = (e) => {
    setEndpointContext(e.target.value)
    validateContext(e.target.value)
  };

  const handleCancelDetail = () => {
    setAddActivityModal(false)
    setSelectedActivity(initialEndpoint)
    setEndpointNum(null)
    setEndpointType('')
    setEndpointContext('')
    setEnpointTypeError('')
    setTimepointsError('')
    setTimepointsLimitError('')
    setErrorIndices([])
    setContextError('')  
    setExpandActiveKey([])
    setWhetherExpand(false)
    setCurrentSlide(0)
    setSelectedOptions([]);
  }

  const validateEndpointType = (rawValue) => {
    let errorMsg = ""
    if(rawValue===null||rawValue===""||!rawValue )
    {
      errorMsg = "Endpoint Type is required"
    }
    setEnpointTypeError(errorMsg)
    return errorMsg == ""
  }

  const validateTimepoints = (rawValue) => {
    let value = parseInt(rawValue)
    let errorMsg = ""
    if(rawValue===null||(!rawValue && value!== 0)||value === 0){
      errorMsg = "Endpoint timepoints is required"
    } else{
      setTimepointsLimitError('')
    }
    setTimepointsError(errorMsg)
    return errorMsg == ""
  }

  const validateDuration = (detailData) => {
     let errorMsg = ""
     let errorMsgArray = []
     let nonNumErrorMsgArray = []
     let limitErrorMsgArray = []
     let tempErrorIndices = [];
     detailData.forEach((item,index) => {
      let rawValue = item["modifiers"]
      let value = parseInt(rawValue)
      if (rawValue && !/^\d+$/.test(rawValue)) {
        nonNumErrorMsgArray.push(1)
        tempErrorIndices.push(index);
        setErrorIndices(tempErrorIndices);
      } else if (rawValue && (value > 1000 || value < 0)) {
        limitErrorMsgArray.push(1)
        tempErrorIndices.push(index);
        setErrorIndices(tempErrorIndices);
      } else if (!(rawValue === null || (!rawValue && value !== 0) || isNaN(value) || isNaN(rawValue))) {
        errorMsgArray.push(1)
      }
    });
     if (nonNumErrorMsgArray.length > 0) {
      errorMsg = "Please enter a valid timepoint. Timepoint must be a non-negative whole number."
      setTimepointsLimitError(errorMsg)
      
    } else if (limitErrorMsgArray.length > 0) {
      errorMsg = "My Timepoints should be between 0 to 1000"
      setTimepointsLimitError(errorMsg)
    }else if (detailData.every(item => !item['modifiers'])) {
      errorMsg = "Please enter at least one timepoint to continue.";
      setTimepointsLimitError(errorMsg);
      setErrorIndices(detailData.map((_, index) => index));
    } else {
      setErrorIndices([]);
      setTimepointsLimitError('');
    }
    
    return errorMsg == ""
  }
  const validateContext = (contextValue) => {
      if (contextValue.length > 500) {
        setContextError("Context should be within 500 characters");
      } else {
        setContextError("");
      }
  };

  const handleUpdateDetail = (e, evt) => { 
    validateEndpointType(endpointType)
    validateTimepoints(endpointNum)
    validateDuration(detailData)
    let userDuration = []
    detailData.filter((item)=>item["modifiers"]!==null&&item["modifiers"]!=='').forEach(item => {
      userDuration.push(Number(item["modifiers"]))
    });
    
    if(!validateEndpointType(endpointType)||!validateTimepoints(endpointNum)|| !validateDuration(detailData)|| contextError){
      return
    }

    const newItem = Object.assign({...evt},{
      "endpoint_context":endpointContext?endpointContext:'',
      "endpoint_type":endpointType,
      'user_duration':userDuration.sort((a, b) => a - b)
    })  
    // Send updated data to the parent component
    props.handleDetailUpdate(newItem)

    handleCancelDetail()
  }
  
  const onCopyToMyModifier = () =>{

    let topData = selectedActivity['hist_measure_timepoints'] ?
                        [...selectedActivity['hist_measure_timepoints']]
                        .filter(item => item.number_of_studies !== 0)
                        .sort((a, b) => b.number_of_studies - a.number_of_studies)
                        .slice(0, endpointNum)
                        : [];

    let sortedData = topData ?
                        [...topData].sort((a, b) => a.duration - b.duration)
                        : [];

    let returnData = [];
    for (let index = 0; index < endpointNum; index++) {
        returnData.push( {
        key: index+1+'',
        name: '',
        history: sortedData&&sortedData[index]?.duration || null,
        modifiers: sortedData&&sortedData[index]?.duration || null,
      });
    }

    setDetailData(returnData);
    setTimepointsLimitError('');
    setErrorIndices([]);

  }

  const usageChartOption = { 
    grid: {
      top: 50,
      left: '10%',
      right: '5%'
    },
    xAxis: {
        type: 'category',
        name: 'Protocol approval year', 
        data: selectedActivity['hist_usage_data'] && selectedActivity['hist_usage_data'].length > 0 && missingYearsFill(selectedActivity).years,  
        axisLabel: {
          show: true,
          rotate: 45
        },
        nameLocation: 'middle',
        nameGap: 35,
        nameRotate: 0,
    },
    yAxis: {
      type: 'value',
      name: '% of trials using endpoint measure',
      min: 0,
      nameLocation: 'middle',
      nameGap: 35,
      axisLabel: {
        formatter: function (value) {
          return value ? roundToTwoDecimals(value * 100) + "" : "";
        }
      },
  },
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: function (param) {
        return param?.value ? roundToTwoDecimals(param?.value * 100) + "" : "";
      }
    },
    series: [
        {
            type: 'bar',
            data: selectedActivity['hist_usage_data']&&selectedActivity['hist_usage_data'].length > 0 &&missingYearsFill(selectedActivity).selected_activity_obj.map((item,index)=>{
              return item.primary
            }),
            itemStyle: {
              color: '#295477'
            }
        },
        {
          type: 'bar',
          data: selectedActivity['hist_usage_data']&&selectedActivity['hist_usage_data'].length > 0&&missingYearsFill(selectedActivity).selected_activity_obj.map((item,index)=>{
            return item.secondary
          }),
          itemStyle: {
            color: '#4577C9'
          }
      }
    ]
  };

  const measureChartOption = { 
    grid: {
      top: 30,
      left: '5%',
      right: '5%',
      bottom: '30%' // Adjust the bottom margin as needed
    },
    xAxis: {
        type: 'category',
        name: 'Timepoint (Weeks)', 
        data: selectedActivity['hist_measure_timepoints']&&selectedActivity['hist_measure_timepoints']?.map((item,index)=>{
          return item?.duration_range
        }) ,
        nameLocation: 'center',
        nameRotate: 0,
        axisLabel: {
          show: true,
          rotate: 45
        },
        nameGap: 45,
    },
    yAxis: {  
      type: 'value',  
      name: 'Number of trials',  
      min: 0,  
      nameLocation: 'center',  
      nameGap: 25,  
      axisLabel: {  
        show: true,   
      },  
      splitLine: {  
        show: false,   
      },  
  },  
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: function (param) {
        return param?.value + "";
      }
    },
    series: [
        {
          type: 'bar',
          data: selectedActivity['hist_measure_timepoints']&&selectedActivity['hist_measure_timepoints']?.map((item,index)=>{
            return item?.number_of_studies
          }),
          itemStyle: {
            color: '#EB8C00'
          }
        }
    ]
  };
  
  const onCarouselChange = (currentSlide: number) => {
    setCurrentSlide(currentSlide)
  };

  const cleanString = (str) => {  
    return str  
      .replace(/\(\s+/g, '(')  // Remove space after '('  
      .replace(/\s+\)/g, ')')  // Remove space before ')'  
      .replace(/\s*-\s*/g, '-') // Remove spaces around '-'  
      .trim(); // Remove leading and trailing spaces  
  }  

  const endpointOptions = [
    { value: 'Primary', label: 'Primary endpoints' },
    { value: 'Secondary', label: 'Secondary endpoints' },
    { value: 'Exploratory', label: 'Exploratory endpoints' },
  ];

  const isEndpointSelected = (endpointType) => selectedOptions.includes(endpointType);

  const filteredStudies = selectedActivity.details?.filter((item) => {
    if (selectedOptions.length === 0) {
      return true; 
    }
    return selectedOptions.some(option => item.additional_details[option]?.length > 0);
  });

  const renderEndpoints = (item: any, endpointType: string) => {
    const endpoints = item.additional_details[endpointType];
    if (!endpoints || endpoints.length === 0) return null;
  
    return (
      <div>
        {(selectedOptions.length === 0 || multipleEndpointSelected) && (
          <h6><strong>{endpointType}:</strong></h6>
        )}
        {endpoints.map((endpoint: any, index: number) => {
          const cleanedEntity = cleanString(endpoint.endpoint_entity);
          const cleanedMeasure = cleanString(endpoint.endpoint_measure);
          return (
            <p
              dangerouslySetInnerHTML={{
                __html: cleanedMeasure.split(cleanedEntity).join(`<b>${cleanedEntity}</b>`),
              }}
              key={index}
            ></p>
          );
        })}
      </div>
    );
  };
  
  const constructSelectedOptionsToDisplay = (value, closable, onClose) => {
    return <span className="ant-select-selection-item">
              {value}
              {closable && <span className="ant-select-selection-item-remove" onClick={onClose}>×</span>}
            </span>;
  }
  const deselectSelectedOption = () => {
    setSelectedOptions([]);
  };
  return (
    <div>
      <Modal 
      visible={addActivityModal} 
      title="" 
      closable={false} 
      mask={false} 
      onCancel={handleCancelDetail} 
      footer={null} 
      style={{ top: 5 }} 
      centered={false} 
      maskClosable={false}
      destroyOnClose={true}  
      wrapClassName="endpointDetailModal"
      >
      <Row className="endpoint-configure-title">
        <span>Endpoint details</span>
      </Row>
      <Row className="endpoint-modal-filed">
        <Col span={24} className="endpoint-text">
        <div className="name" style={{fontWeight: 700}}>{selectedActivity['endpoint_std_term']}</div>
        <div className="categories">{selectedActivity['endpoint_category']}</div>
        {currentSlide === 2 && (
          <div className="action-container">
           <Select
              className="select-endpoints"
              mode="multiple"
              showSearch={false}
              value={selectedOptions}
              onChange={handleChange}
              style={{display: currentSlide === 2 ? 'inline-block' : 'none'}}
              placeholder="Select endpoint type"
              open={open}
              onFocus={() => setOpen(true)}
              onBlur={() => setOpen(false)}
              onDropdownVisibleChange={(open) => setOpen(open)}
              tagRender={(props) => {
                const { label, value, closable, onClose } = props;
                if (selectedOptions?.length === endpointOptions?.length && value === endpointOptions[0]?.value) {
                 return constructSelectedOptionsToDisplay('All', closable, deselectSelectedOption);
                }else if (selectedOptions?.length !== endpointOptions?.length){
                 return constructSelectedOptionsToDisplay(value, closable, onClose);
                }
              }}
          >
            {endpointOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                  {option.label}
              </Option>
            ))}
          </Select>
          <DownOutlined style= {{fontSize: '12px',
                        position: 'absolute',
                        right:whetherExpand? '126px': '266px', 
                        top: '65%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'auto', 
                        cursor: 'pointer',
                      }}
            onClick={() => setOpen(!open)}
          />

          <Button
              className="expand-btn" 
              style={{display: currentSlide === 2 ? 'inline-block' : 'none'}}
              onClick={()=>{
                  setWhetherExpand(!whetherExpand)
                  setExpandActiveKey(whetherExpand?[]: expandArray)
              }}
          >
            {whetherExpand ? 'Hide all' : 'Expand all for more details'}
          </Button>
        </div>
        )}
        </Col>
        <Col span={24} className="endpoint-chart">
        <Carousel 
        afterChange={onCarouselChange}
        >
          <div className="wrapper">
            <div className="title">
            Frequency trend across selected trials
            </div>
            <div className="content-wrapper">
              <div className="left">
                <ReactECharts style={{height: '300px'}} option={usageChartOption}></ReactECharts> 
              </div>
              <div className="right">
                <div className="count">
                  <span className="text">
                  # Total trials <br/>
                  containing endpoint measure
                  </span>
                  <span className="number">
                    {selectedActivity['total_trial']}
                  </span>
                </div>

                <div className="trending">
                  <span className="text">
                    { selectedActivity['trend'] && ( <>{`* Endpoint usage is trending ${selectedActivity['trend'].toLowerCase()} over the last 4 years`}</> )}
                  </span> 
                </div>

                <div className="frequency">
                  <span className="circle">
                  </span>
                  <span className="text">
                  Primary endpoint frequency
                  </span>
                </div>
                <div className="number">
                  {Math.round(selectedActivity['primary_frequency'] * 10000) / 100 + "%"}
                </div>
                <div className="frequency">
                  <span className="circle sec">
                  </span>
                  <span className="text">
                  Secondary endpoint frequency
                  </span>
                </div>
                <div className="number">
                  {Math.round(selectedActivity['secondary_frequency'] * 10000) / 100 + "%"}
                </div>
              </div>
            </div>
          </div>
          <div className="wrapper">
            <div className="title">
              Measure timepoints in similar historical trials
            </div>
            <div className="content-wrapper">
              <div className="whole">
                <ReactECharts style={{height: '300px'}} option={measureChartOption}></ReactECharts> 
              </div>
            </div>
          </div>
          <div className="wrapper">
            <div className="line"></div>
            <div className="content-wrapper">
              <Collapse 
                expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
                activeKey={expandActiveKey}
                onChange={(key)=>{
                  setWhetherExpand(false)
                  setExpandActiveKey(Array.isArray(key) ? key : [key])         
                }}
                bordered={false} 
                expandIconPosition="right"
                className="endpoint-collapse-detail-collapse"
                >
                  {filteredStudies?.map((item, index) => {
                    return (
                      <Panel header={item?.study_nct_id} key={index+1+''} className="endpoint-collapse-detail-panel">
                        <p>{`${item?.sponsor} | ${item?.study_phase}`}</p>
                        {endpointOptions.map(({ value }) =>
                          (selectedOptions.length === 0 || isEndpointSelected(value)) && renderEndpoints(item, value)
                        )}
                      </Panel>
                    )
                  })}
              </Collapse>
            </div>
          </div>
        </Carousel>
        </Col>
      </Row>
      <br />
      <Row className="endpoint-selector">
        <Col span={24}>
            <div className="title">
              <span className="required">* </span>
              Select endpoint type
            </div>
            <div className="des">
            <Radio.Group onChange={onEndpointTypeChange} value={endpointType} className="radio">
              <Radio value={'Primary'}>Primary</Radio>
              <Radio value={'Secondary'}>Secondary</Radio>
              <Radio value={'Exploratory'}>Exploratory</Radio>
            </Radio.Group>
            </div>
            <div className="input-error" style={{marginLeft: 50}}><span>{enpointTypeError}</span></div>
        </Col>
      </Row>
      <Row className="timepoint-selector">
        <Col span={24}>
          <div className="title">
            <span className="required">* </span>
            Select endpoint timepoints
          </div>
          <div className="des">
            <div className="des-text">
            At how many timepoints will the endpoint be measured?
            </div>
            <div className="input-box">
              <InputNumber 
              min={1} 
              max={50}
              // defaultValue={5} 
              value={endpointNum}
              onChange={onInputNumberChange} />
              <span className="limit"> (Max value allowed - 50)</span>
            </div>
            <div className="input-error"><span>{timepointsError}</span></div>

           {endpointNum && endpointNum > 0 && ( <div className="header">
            
            <div className="history">
              <div className="top">
              <span className="title-text">
                Most common timepoints
              </span>
              </div>
             
            </div>
            <div className="modifier">
              <span className="title-text">
              My timepoints
              </span>
            </div>  
           </div>)}
          <div className="input-list-wrapper">
            {detailData.map((item, index) => {
              return (
                <>
                <div className="row" key={item.key}>
                    <div className="hist">
                      <span style={{fontWeight: 600}}>{item['history']?`${item['history']}`:`- ` } </span>
                      <span> Weeks</span>
                    </div>
                    <div className="my" style={{ 
                      position: 'relative', 
                      zIndex: 9999,
                    }}>
                    
                      <Input 
                      style={{
                          width: "100px",
                          fontSize: 14,
                          border: errorIndices.includes(index) ? '1px solid #E72B33' : ''
                        }} 
                      value={item['modifiers']}
                      onChange={(e) => {
                        let temp = [...detailData]
                        temp[index]['modifiers'] = e.target.value
                        setDetailData(temp)
                        validateDuration(temp)
                      }}
                      />
                      <span> Weeks</span>
                    </div>
                </div>
                </>
              )
            })}
            { endpointNum && endpointNum > 0 && ( <div className="bottom">
                <Button 
                style={{marginTop: 5}}
                size="small"
                onClick={onCopyToMyModifier}
                >
                  Copy most common timepoints
                </Button>
                {/* error message for limit 1 to 1000 */}
                <div className="input-error" style={{marginTop: 5}}><span>{timepointsLimitError}</span></div>
              </div> )}
          </div>
          </div>  
        </Col>
      </Row>
      <Row className="endpoint-context">
        <Col span={24}>
          <div className="title">
            Add context
          </div>
          <div className="des">
            <div className="context-box">
              <Input 
                placeholder="Percent of patients with reduction"
                style={{ width: "300px", fontSize: 14}} 
                value={endpointContext}
                onChange={onContextChange}
                />
            </div>
            {contextError && (
            <div className="input-error"><span>{contextError}</span></div>
          )}
          </div> 
        </Col>
      </Row>
     
      <Row className="button-wrapper">
        <Button className="cancel-btn" onClick={handleCancelDetail}>Cancel</Button>
        <Button className="create-btn" 
        onClick={(e) => handleUpdateDetail(e, selectedActivity)}>{ isBuilderTable ? 'Submit' : 'Add'}</Button>
      </Row>
      </Modal> 
    </div>    
  )
}

export default EndpointDetails;